import { CLIENT_DOCUMENT_ISSUED_BY } from '../constants';

// Ð ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð¾ÑÐ³Ð°Ð½ ÑÑÐ°Ð½Ð¸ÑÑÑ ÐºÐ¾Ð´Ð¾Ð¼ (1 â ÐÐÐ Ð Ð, 2 â ÐÐ® Ð Ð), Ð° ÐÐÐ Ð¿ÑÐ¸ÑÑÐ»Ð°Ð» ÐµÐ³Ð¾ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸ÐµÐ¼, ÑÑÑÑÐºÐ¸Ð¼ Ð¸Ð»Ð¸
// ÐºÐ°Ð·Ð°ÑÑÐºÐ¸Ð¼ (Â«ÒÐ  ÐÐ¨ÐÐ ÐÐ¡Ð¢ÐÐ  ÐÐÐÐÐ¡Ð¢Ð ÐÐÐÐÂ») â Ð¿ÑÐ¸Ð²Ð¾Ð´Ð¸Ð¼ Ðº ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÑ.
export const resolveIssuer = (raw) => {
  if (raw === null || raw === undefined || raw === '') return undefined;

  const byCode = CLIENT_DOCUMENT_ISSUED_BY.find((item) => item.value === Number(raw));
  if (byCode) return byCode;

  const text = String(raw).toLowerCase();
  if (text.includes('Ð²Ð½ÑÑÑÐµÐ½Ð½') || text.includes('Ð¼Ð²Ð´') || text.includes('ÑÑÐºÑ ÑÑÑÐµÑ')) {
    return CLIENT_DOCUMENT_ISSUED_BY[0];
  }
  if (text.includes('ÑÑÑÐ¸Ñ') || text.includes('ÓÐ´ÑÐ»ÐµÑ') || text.includes('Ð¼Ñ')) return CLIENT_DOCUMENT_ISSUED_BY[1];
  return undefined;
};
